import React from 'react'
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

export default function BackIcon() {
    return (
        <ArrowBackIosIcon
            className="!text-white !rounded-full"
            style={{
                color: "white",
                padding: "0 6px 0 10px",
                height: "32px",
                width: "32px",
                background: "#e09145",
            }}
        />

    )
}
